import { useEffect, useState } from "react";
import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import {
  isAuthenticated,
  addExpense,
} from "../../../ApiService/ApiService";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import CustomDialog from "../../../Components/CustomDialog";

function AddExpense({ fetchExpenses, setShowAddExpense, expenseCategory }) {
  const schoolId = parseInt(sessionStorage.getItem("schoolId"));
  const [formData, setFormData] = useState({
    schoolId: schoolId,
    categoryId: "",
    expanseDate: "",
    details: "",
    amount: "",
  });
  const [loading, setLoading] = useState(false);
  const [dialog, setDialog] = useState({
    visible: false,
    title: "",
    message: "",
    buttons: [],
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "amount") {
      setFormData({
        ...formData,
        [name]: parseFloat(value),
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleDialogClose = () => {
    setDialog({ ...dialog, visible: false });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !formData.details ||
      !formData.amount ||
      !formData.expanseDate ||
      !formData.categoryId
    ) {
      setDialog({
        visible: true,
        title: "Error",
        message: "Please fill all the details",
        buttons: [{ name: "OK", onPress: handleDialogClose }],
      });
      return;
    }
    setLoading(true);
    try {
      if (isAuthenticated()) {
        const response = await addExpense(formData);
        if (response) {
          if (response?.data?.status === 200) {
            setDialog({
              visible: true,
              title: "Success",
              message: "Expense added",
              buttons: [{ name: "OK", onPress: handleDialogClose }],
            });
            setFormData({
              schoolId: schoolId,
              categoryId: "",
              expanseDate: "",
              details: "",
              amount: "",
            });
            fetchExpenses();
            setShowAddExpense(false);
          } else {
            const errorMessage =
              response?.data?.errorMessage || "Something went wrong";
            setDialog({
              visible: true,
              title: "Error",
              message: errorMessage,
              buttons: [{ name: "Close", onPress: handleDialogClose }],
            });
          }
        } else {
          setDialog({
            visible: true,
            title: "Error",
            message: "Invalid response from the server",
            buttons: [{ name: "Close", onPress: handleDialogClose }],
          });
        }
      } else {
        setDialog({
          visible: true,
          title: "Unauthorized action",
          message: "Please login and try again",
          buttons: [{ name: "Close", onPress: handleDialogClose }],
        });
      }
    } catch (error) {
      console.error("Failed to add expense", error);
      setDialog({
        visible: true,
        title: "Error",
        message: "Failed to add expense",
        buttons: [{ name: "Close", onPress: handleDialogClose }],
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <CustomDialog
        visible={dialog.visible}
        title={dialog.title}
        message={dialog.message}
        buttons={dialog.buttons}
        onClose={handleDialogClose}
      />
      <Box sx={{ maxWidth: "75%", margin: "auto", padding: 3 }}>
        <Paper elevation={3} sx={{ padding: 5 }}>
          <Typography
            variant="h6"
            gutterBottom
            sx={{ fontWeight: 600, fontSize: 22, color: "black" }}
          >
            Add Expense
          </Typography>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  label="Details"
                  name="details"
                  id="details"
                  type="text"
                  value={formData.details}
                  onChange={handleChange}
                  size="small"
                  required
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <FormControl fullWidth>
                  <InputLabel id="expenseCategory" size="small">
                    Category *
                  </InputLabel>
                  <Select
                    id="expenseCategoryId"
                    name="categoryId"
                    labelId="expenseCategory"
                    value={formData.categoryId}
                    onChange={handleChange}
                    label="Category"
                    size="small"
                    required
                  >
                    {expenseCategory.map((category) => (
                      <MenuItem key={category.id} value={category.id}>
                        {category.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Typography
                  sx={{ fontSize: 14, marginBottom: 1, marginLeft: 1 }}
                >
                  Expense Date *
                </Typography>
                <TextField
                  fullWidth
                  name="expanseDate"
                  type="date"
                  labelid="expenseDate"
                  value={formData.expanseDate}
                  onChange={handleChange}
                  size="small"
                  required
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  type="number"
                  fullWidth
                  label="Amount"
                  name="amount"
                  id="amount"
                  value={formData.amount}
                  onChange={handleChange}
                  size="small"
                  required
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <Button
                  fullWidth
                  variant="contained"
                  color="inherit"
                  onClick={() => setShowAddExpense(false)}
                  startIcon={<ArrowBack />}
                  sx={{ textTransform: "unset" }}
                >
                  Back
                </Button>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <Button
                  fullWidth
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={loading}
                  endIcon={<ArrowForward />}
                  sx={{ textTransform: "unset" }}
                >
                  {loading ? "Loading..." : "Submit"}
                </Button>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </Box>
    </>
  );
}

export default AddExpense;
